import { useContext } from 'react';

import { ExaminationCourseContext } from './examination-course-provider';

function useExaminationCourse() {
  const context = useContext(ExaminationCourseContext);

  if (!context) {
    throw new Error('useExaminationCourse must be used within a ExaminationCourseProvider');
  }

  return context;
}

export { useExaminationCourse };
